import type { AttributeNode } from '@/types/schemas';
import { SchemaFieldRow } from './SchemaFieldRow';

export function SchemaFieldTree(props: {
  nodes: AttributeNode[];
  included: Record<string, boolean>;
  onToggle: (path: string, next: boolean) => void;
  selectedPath: string | null;
  onSelect: (path: string) => void;
  isOpen: (path: string) => boolean;
  onToggleOpen: (path: string) => void;
  depth?: number;
  parentPath?: string | null;
  disabled?: boolean;
}) {
  const {
    nodes,
    included,
    onToggle,
    selectedPath,
    onSelect,
    isOpen,
    onToggleOpen,
    depth = 0,
    parentPath = null,
    disabled = false,
  } = props;
  return (
    <div className="space-y-2">
      {nodes.map((n) => {
        const path = parentPath ? `${parentPath}.${n.key}` : n.key;
        const hasChildren =
          (n.type === 'object' && (n.attributes?.length ?? 0) > 0) || (n.type === 'array' && !!n.items);

        return (
          <SchemaFieldRow
            key={n.id}
            node={n}
            path={path}
            depth={depth}
            included={included}
            onToggle={onToggle}
            selectedPath={selectedPath}
            onSelect={onSelect}
            disabled={disabled}
            hasChildren={hasChildren}
            open={isOpen(path)}
            onToggleOpen={() => onToggleOpen(path)}
          >
            {hasChildren ? (
              <SchemaFieldTree
                nodes={
                  n.type === 'object'
                    ? (n.attributes ?? [])
                    : n.type === 'array' && n.items
                      ? [n.items] // show "item" node under the array
                      : []
                }
                included={included}
                onToggle={onToggle}
                selectedPath={selectedPath}
                onSelect={onSelect}
                depth={depth + 1}
                parentPath={path}
                disabled={disabled}
                isOpen={isOpen}
                onToggleOpen={onToggleOpen}
              />
            ) : null}
          </SchemaFieldRow>
        );
      })}
    </div>
  );
}
